'use strict';

/**
 * Flight Analysis - Chart (metric: Loadfactor, Revenue)
 */
var FlightCabinCurveTransformerFactory = function FlightCabinCurveTransformerFactory($filter, DataTransformer) {
  function FlightCabinCurveTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['flight-cabin-profile-mode'];
    this.priority = 0;
  }
  FlightCabinCurveTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightCabinCurveTransformer.constructor = FlightCabinCurveTransformer;
  FlightCabinCurveTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) > -1;
  };
  FlightCabinCurveTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightCabinCurveTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType.join('-') + '-' + metrics.join('-');
  };
  FlightCabinCurveTransformer.prototype.transform = function (data) {
    return data.domain.flattenedDomainCurves || data.domain.results;
  };
  return FlightCabinCurveTransformer;
};
FlightCabinCurveTransformerFactory.$inject = ['$filter', 'DataTransformerFactory'];
module.exports = FlightCabinCurveTransformerFactory;